// jshint esversion: 8
import idxById from '@/utils/idxById';

export default {
  SET_PLANNER: (state, payload) => state.planner = payload,
  SET_TRIP: (state, payload) => state.trip = payload,
  SET_ROUTE: (state, payload) => state.route = payload,
  SET_DEAD_HEADS: (state, payload) => state.deadHeads = payload,
  SET_STOPS: (state, payload) => state.stops = payload,
  SET_QUOTE: (state, payload) => state.quote = payload,
  UPDATE_STOPS_BY_ID: (state, payload) => state.stops[idxById(state.stops, payload.id)] = payload
};
